import { useEffect } from 'react';
import AOS from 'aos';
import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';
import ContactFloat from '../components/ContactFloat';
import WebsiteBanner from '../components/BannerKm';
import PainPointSection from './home/PainPointSection';
import SolutionSection from './home/SolutionSection';
import AdvantageSection from './home/AdvantageSection';
import ResourceSection from './home/ResourceSection';
import CaseSection from './home/CaseSection';

export default function Home() {
  const { t } = useTranslation();

  useEffect(() => {
    AOS.init({
      offset: 100,
      easing: 'ease-out-back',
      duration: 1000,
      delay: 100
    });
  }, []);

  return (
    <>
      <Helmet>
        <title>{t('home.title')}</title>
        <meta name="keywords" content={t('home.keywords')} />
        <meta name="description" content={t('home.description')} />
      </Helmet>
      <ContactFloat />
      <WebsiteBanner />
      {/* <WebsiteBanner title="专注跨境电商英语客服" subtitle="菲律宾本地团队，24 小时多语种响应" ctaText="免费咨询方案" ctaHref="/contact" backgroundClassName="可以加额外背景图案" personSrc="/images/b1.png" /> */}
      {/** 行业痛点 */}
      <PainPointSection />
      {/** 解决方案 */}
      <SolutionSection />
      {/** 独到优势 */}
      <AdvantageSection />
      {/** 资源优势 */}
      <ResourceSection />
      {/** 合作案例 */}
      <CaseSection />

    </>
  );
}


